// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Components
import EditExpenseBill from 'components/models/purchases/edit-expense-bill';
import FormPopover from 'components/widgets/overlays/form';
import { SVGButton } from 'components/widgets/buttons/buttons';
import Tooltip from 'components/widgets/overlays/tooltip';
import SVG from 'components/widgets/icons/svg';


// Component
export default class EditExpenseBillPopup extends React.Component {
  static propTypes = {
    expenseBill: PropTypes.object,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.editForm = {};
    this.closeForm = this.closeForm.bind(this);
  }

  closeForm() {
    this.editForm.toggle();
  }

  render() {
    const { expenseBill, className, ...passed } = this.props;

    return (
      <div className={className}>
        { !expenseBill.invoice &&
          <FormPopover
            ref={(el) => { this.editForm = el; }}
            target={<SVGButton src="svg/edit.svg" className="edit-button edit-link" />}
            title="Edit Expense Bill"
            popoverClassName="edit-expense-bill"
          >
            <EditExpenseBill
              {...passed}
              expenseBill={expenseBill}
              form={`edit-expense-bill-popup-${expenseBill.id}`}
              cancel={this.closeForm}
            />
          </FormPopover>
        }
        { expenseBill.invoice &&
          <Tooltip title="This charge has been invoiced and can't be edited">
            <SVG src="svg/edit.svg" className="svg-only-button deemphasized-button disabled" />
          </Tooltip>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/purchases/forms/edit-expense-bill-popup.js